<template>
  <div class="legislation">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Dados da Legislação</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Título
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="legislation.title" class="form-control" />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>Ementa</label>
                    <textarea v-model="legislation.ementa" cols="30" rows="4" class="form-control"></textarea>
                  </div>
                </div>
                <div class="col-12" v-if="legislation.content || formType == 'create'">
                  <div class="form-group">
                    <label for>
                      Texto
                      <span class="required-field">*</span>
                    </label>
                    <text-editor-component
                      :textContent="legislation.content"
                      @updateContentComponent="updateContent"
                    ></text-editor-component>
                  </div>
                </div>
                <div class="col-lg-9 col-12">
                  <div class="form-group">
                    <label for>Site</label>
                    <input type="text" v-model="legislation.link" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-3 col-12">
                  <div class="form-group">
                    <label for>
                      Número/Ano
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" v-model="legislation.number_law" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-12 col-12">
                  <div class="form-group">
                    <label for>
                      Permissão de acesso
                      <span class="required-field">*</span>
                    </label>
                    <multiselect
                      v-model="magazines"
                      :multiple="true"
                      :options="createParams.magazines"
                      selectLabel="Selecione essa revista"
                      deselectLabel="Remova essa revista"
                      selectedLabel="Selecionada"
                      track-by="id"
                      label="name"
                      placeholder="Selecione as revistas"
                    ></multiselect>
                  </div>
                </div>
                <div class="col-lg-12 col-12">
                  <div class="form-group">
                    <label for>
                      Categoria
                      <span class="required-field">*</span>
                    </label>
                    <select class="form-control" v-model="legislation.legislation_category_id">
                      <option
                        v-for="item in createParams.legislation_categories"
                        v-bind:key="item.id"
                        :value="item.id"
                      >{{item.name}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button
                    class="btn btn-primary float-right"
                    style="margin-left: 12px"
                    v-on:click="save()"
                  >Salvar</button>
                  <button
                    class="btn btn-secondary float-right"
                    v-if="formType == 'edit'"
                    v-on:click="destroy()"
                  >Excluir</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import Multiselect from "vue-multiselect";
import legislation_validate from "@/imports/validator/models/legislation";
import validator from "@/imports/validator/validate";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "legislation",
  props: {
    id: Number
  },
  components: {
    TextEditorComponent,
    Multiselect
  },
  data() {
    return {
      formType: "create",
      magazines: [],
      legislation: {},
      createParams: {
        magazines: [],
        legislation_categories: []
      },
      items: [
        {
          text: "Legislações",
          route: "admin.legislations"
        },
        {
          text: "Nova Legislação",
          active: true
        }
      ]
    };
  },
  mounted() {
    bus.$emit("changeLoading", true);
    this.getCreateParams();
  },
  methods: {
    updateContent: function(val) {
      this.legislation.content = val;
    },
    getDataObject: function(id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/legislations/${id}`)
        .then(response => {
          this.legislation = response.data;
          this.magazines = this.legislation.magazines;
          this.items[1].text = this.legislation.title;

          bus.$emit("changeLoading", false);
        });
    },
    getCreateParams: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/legislations/create`)
        .then(data => {
          this.createParams = data.data;
          if (this.id) {
            this.formType = "edit";
            this.getDataObject(this.id);
          } else {
            bus.$emit("changeLoading", false);
          }
        });
    },
    save: function() {
      this.legislation.magazines = [];
      this.magazines.forEach(el => this.legislation.magazines.push(el.id));

      let errors = validator.validate(
        this.legislation,
        legislation_validate.model
      );

      if (errors.length == 0) {
        bus.$emit("changeLoading", true);

        let promise =
          this.formType == "create"
            ? axios.post(
                `${process.env.VUE_APP_API_HOST}/api/legislations`,
                this.legislation
              )
            : axios.put(
                `${process.env.VUE_APP_API_HOST}/api/legislations/${this.legislation.id}`,
                this.legislation
              );

        promise
          .then(response => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title:
                this.formType == "create"
                  ? "Nova legislação cadastrado"
                  : "Legislação alterada com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.legislations" });
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        let html = "Preencha todos os campos obrigatórios.";
        if (errors.length < 4) {
          html = "";
          errors.forEach(el => (html += el.message + "<br>"));
        }
        Swal.fire({
          title: "Atenção",
          html: html,
          icon: "warning"
        });
      }
    },
    destroy: function() {
      Swal.fire({
        title: "Você tem certeza que deseja excluir esse item?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.value) {
          let promise = axios.delete(
            `${process.env.VUE_APP_API_HOST}/api/legislations/${this.legislation.id}`
          );

          promise.then(response => {
            Swal.fire({
              title: "Item excluído com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.legislations" });
              }
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>